import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface ICompanyTokenService {
  companyId?: string;
  integratorId?: string;
  reqBody?: ReqBodyType;
}

class CompanyTokenService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_NEST_API ?? '', false);
  }

  getCompanyToken = async ({
    companyId,
    integratorId,
  }: ICompanyTokenService) => {
    return this.httpClient.get({
      token: process.env.REACT_APP_NEST_API_TOKEN as string,
      path: `/utils/company-token?companyId=${companyId}&integratorId=${integratorId}`,
    });
  };
}

export default new CompanyTokenService();
